import { render, staticRenderFns } from "./StudentViewCredit.vue?vue&type=template&id=e337991e&"
import script from "./StudentViewCredit.vue?vue&type=script&lang=js&"
export * from "./StudentViewCredit.vue?vue&type=script&lang=js&"
import style0 from "./StudentViewCredit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports